import { useState } from 'react';
import { message, Col, Drawer, Form, Input, Row } from 'antd';
import { drawerWidth, formItemLayout, notifyMessages } from '../../utils/constants';
import { DrawerFormButtons } from '../../components/common/drawersFormButtons';
import DivisionsServices from '../../services/divisionsServices';
import { errorAlertDisplay } from '../../utils/functions';

const NewDivision = ({ open, onClose, getDivisions }) => {

    const [fieldsChanged, setFieldsChanged] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const saveData = async (values) => {
        setLoadingButton(true);

        try {
            const respData = await DivisionsServices.createDivision(values);
            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                setLoadingButton(false);
                getDivisions();
                onClose();
            }
            else {
                errorAlertDisplay(respData);
                setLoadingButton(false);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingButton(false);
        }
    };

    return (
        <Drawer
            title="Aggiungi divisione"
            width={drawerWidth}
            onClose={onClose}
            destroyOnClose={true}
            open={open}
            extra={
                <DrawerFormButtons disabled={!fieldsChanged} close={onClose} loadingButton={loadingButton} formId={"newDivision"} />
            }
        >
            <Form
                id="newDivision"
                layout="vertical"
                {...formItemLayout}
                onFinish={(values) => saveData(values)}
                onValuesChange={() => setFieldsChanged(true)}
            >
                <Row gutter={16}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                        <Form.Item
                            label="Nome"
                            name="name"
                            rules={[{ required: true, message: notifyMessages.requiredField }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}
export default NewDivision;